var React = require('react');

function FileMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-88 212a12 12 0 0 1-12 12H100a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h184a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zm-93 183H100a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h184a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12z","className":"fa-primary","key":2})]);
}

FileMinus.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = FileMinus;

FileMinus.default = FileMinus;
